/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import styled from '@emotion/styled';
import { Flex, FlexProps } from '@components/common/primitives';

export type LogoWrapperProps = FlexProps;

export const LogoWrapper = styled(Flex)<LogoWrapperProps>`
  margin-top: -0.8125rem;
  padding: 1.4375rem 0.8125rem;
  justify-content: center;
  background: black;

  & > img {
    width: auto;
    height: 50px;
  }
`;

//TODO: Implement general style HOC and replace defaultProps
LogoWrapper.defaultProps = {
  sx: { mx: ['-1.25rem', '-0.8125rem'] }
};
